import { render } from "./ActionsMenu.vue?vue&type=template&id=fb60840a&scoped=true"
import script from "./ActionsMenu.vue?vue&type=script&lang=js"
export * from "./ActionsMenu.vue?vue&type=script&lang=js"

import "./ActionsMenu.vue?vue&type=style&index=0&id=fb60840a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb60840a"]])

export default __exports__